import * as methods from '../methods';
import { Resource } from '../Resource';
export * from './tavmills.types';
const rootPath = 'oad/tav_mills';
const fromRaw = {
    value: ([T, LW_D]) => ({ T, LW_D }),
    constants: (x) => Object.entries(x).reduce((acc, [k, v]) => {
        acc[k] = v.map(fromRaw.value);
        return acc;
    }, {}),
    results: (xs) => xs.map((x) => ({
        start: x.start,
        end: x.end,
        firstAppleScabbingDate: x.first_tav,
        distance: x.dist,
        isMissingData: x.missing_data,
        values: x.values.map(fromRaw.value),
        status: x.status,
        level: x.level,
        degreeHourCumul: x.cumul_degre_hour
    }))
};
const tavmills = Resource((requesterBuilder) => {
    return {
        constants: (query) => methods.get({
            rootPath: `${rootPath}/constants`,
            fromRaw: fromRaw.constants,
            requesterBuilder,
            params: { query: { crop: query?.cropId } }
        })(),
        results: (query) => methods.get({
            rootPath: `${rootPath}/result`,
            fromRaw: fromRaw.results,
            requesterBuilder,
            params: { query: { crop: query?.cropId } }
        })()
    };
});
export default tavmills;
